import styled from 'styled-components';
import palette from '../../../lib/styles/palette';
import { useRef, useState, useEffect, useCallback } from 'react';

import { MdExpandMore, MdExpandLess, MdRemoveCircleOutline, MdAdd } from 'react-icons/md';
// import ActionButtons from '../ActionButtons';
// import AskCancelModal from '../AskCancelModal';

import { standardDimension } from '../../../lib/data/standard-dimension';
import { toFixedSafe } from '../../../lib/styles/perttierNumber';

const DeckingPlateForm = ({ onSaveStructure, onChangeWeightSummary, deckingPlates, beltWidth }) => {
    const [isShow, setIsShow] = useState(deckingPlates?.length || false);
    const [newDeckingPlate, setNewDeckingPlate] = useState(deckingPlates || []);
    const [factor, setFactor] = useState('1.0');
    const [id, setId] = useState('');
    // const [densityCategory, setDensityCategory] = useState('');
    const [thickness, setThickness] = useState(1.5);
    const [width, setWidth] = useState(720);
    // TODO: 25년 4월 10일 발견. Girder 폭 받아서 그 값을 반영할 것.
    const [length, setLength] = useState('');
    // const [standardWeight, setStandardWeight] = useState('');
    const [unitWeight, setUnitWeight] = useState('');
    const [weight, setWeight] = useState('');
    const [totalLength, setTotalLength] = useState('');
    const [totalWeight, setTotalWeight] = useState('');
    // const [modal, setModal] = useState(false);
    /* 변경사항을 저장했었는지 여부에 대한 상태 저장 */
    const [isChanged, setIsChanged] = useState(false);

    /* standard weight library에서 해당 벨트폭을 뽑아서 저장한다. */
    // const weightLibrary = useRef(null); // chatGPT가 알려준 내용

    /* category 설명하는 text */
    // const densityCategoryText = useRef({
    //     0: '1.0 이하',
    //     1: '1.0초과 2.0이하',
    //     2: '2.0 초과',
    // });

    /*  처음 props로 넘어온 deckingPlates를 초기값 그대로 보관하고 있다가 취소 버튼을 눌렀을 때 원상 복귀 시키기 위해
        useRef를 사용하여 저장해 둔다. */
    // const initialdeckingPlate = useRef(deckingPlates || []);

    /* 벨트폭에 해당하는 Weight Table을 가져온다. */
    useEffect(() => {
        if (!standardDimension || !beltWidth) return;
        const library = standardDimension.find((item) => item.beltWidth === parseInt(beltWidth));
        if (!library) {
            alert('Check Belt Width!!');
            return;
        }
        setWidth(library.girderWidth);
    }, [beltWidth]);

    /* 중량 계산 */
    useEffect(() => {
        if (!width || !thickness) return;

        const _unitWeight = Math.ceil((factor * (thickness * (width + 300) * 1000 * 7.85)) / 1000000);
        const _weight = Math.ceil(length * _unitWeight);
        setUnitWeight(_unitWeight);
        setWeight(_weight);
    }, [length, thickness, width, factor]);

    /* 마지막 deckingPlate ID 가져오기 함수 */
    const getLastId = useCallback(() => {
        if (!newDeckingPlate.length) {
            return 0;
        }
        return Math.max(...newDeckingPlate.map((deckingPlate) => Number(deckingPlate.id.substring(3))), 0);
    }, [newDeckingPlate]);

    /* 입력 후 폼 초기화 함수 */
    const initializeForm = useCallback(() => {
        setId(`DP-${getLastId() * 1 + 1}`);
        // setDensityCategory('');
        // setStandardWeight('');
        // setFactor('');
        setLength('');
        setWeight('');
    }, [getLastId]);

    /* 전체 길이 계산 함수 */
    const getTotalLength = useCallback((items) => {
        const _totalLength = items.reduce((accumulator, currentValue) => {
            return accumulator + parseInt(currentValue.length);
        }, 0);
        setTotalLength(_totalLength);
    }, []);

    /* 전체 중량 계산 함수 */
    const getTotalWeight = useCallback((items) => {
        const _totalWeight = items.reduce((accumulator, currentValue) => {
            return accumulator + currentValue.weight;
        }, 0);
        setTotalWeight(_totalWeight);
    }, []);

    /* 추가 버튼을 누르면 newDeckingPlate에 deckingPlate 추가 */
    const onAddDeckingPlate = useCallback(() => {
        if (!length || !unitWeight || !weight) {
            alert('Check input(s) before saving!!!');
            return;
        }
        const deckingPlate = {
            id,
            thickness,
            unitWeight,
            factor,
            length,
            weight,
        };
        setNewDeckingPlate((prev) => [...prev, deckingPlate]);
        setIsChanged(true);
    }, [factor, id, length, thickness, unitWeight, weight]);

    /* 삭제 버튼을 누르면 해당 deckingPlate 삭제 */
    const onDeleteDeckingPlate = useCallback((id) => {
        setNewDeckingPlate((prev) => prev.filter((deckingPlate) => deckingPlate.id !== id));
        setIsChanged(true);
    }, []);

    /* newDeckingPlate에 변화가 생기면 리덕스에 변경사항 쓰기 */
    useEffect(() => {
        getTotalLength(newDeckingPlate);
        getTotalWeight(newDeckingPlate);
        initializeForm();
        onSaveStructure({
            key: 'deckingPlate',
            value: newDeckingPlate,
        });
        onChangeWeightSummary({
            key: 'deckingPlate',
            value: {
                totalLength,
                totalWeight,
            },
        });
    }, [
        getTotalLength,
        getTotalWeight,
        initializeForm,
        newDeckingPlate,
        onChangeWeightSummary,
        onSaveStructure,
        totalLength,
        totalWeight,
    ]);

    /* Save 버튼을 누르면 리덕스에 변경사항 쓰기 */
    // const onSaveDeckingPlate = useCallback(() => {
    //     onSaveStructure({
    //         key: 'deckingPlate',
    //         value: newDeckingPlate,
    //     });
    //     onChangeWeightSummary({
    //         key: 'deckingPlate',
    //         value: {
    //             totalLength,
    //             totalWeight,
    //         },
    //     });
    // }, [newDeckingPlate, onChangeWeightSummary, onSaveStructure, totalLength, totalWeight]);

    /* 변경 사항을 취소하면 newDeckingPlate를 초기값으로 변경하고 리덕스에 초기값으로 쓰기 */
    // const onCancelChange = useCallback(() => {
    //     setNewDeckingPlate(initialdeckingPlate.current);
    //     onSaveStructure({
    //         key: 'deckingPlate',
    //         value: initialdeckingPlate.current,
    //     });
    //     onChangeWeightSummary({
    //         key: 'deckingPlate',
    //         value: {},
    //     });
    //     setModal(false);
    // }, [onChangeWeightSummary, onSaveStructure]);

    /* Cancel Change 버튼을 눌렀을 때 */
    // const onClickCancel = useCallback(() => {
    //     // 저장된 적이 없다면 alert
    //     if (!isChanged) {
    //         alert('변경내용이 없습니다.');
    //         return;
    //     }
    //     setModal(true);
    // }, [isChanged]);

    return (
        <DeckingPlateFormBlock>
            <Title>
                <h3 style={{ width: '400px', margin: '0' }}>Decking Plate (落粉防止板)</h3>
                <div style={{ width: '120px' }}>Q'ty: {totalLength} m</div>
                <div style={{ width: '170px' }}>Weight: {totalWeight}kg</div>
                <div style={{ fontSize: '1.25rem', fontWeight: 'bold', display: 'flex', alignItems: 'flex-end' }}>
                    {!isShow ? (
                        <MdExpandMore color="orange" onClick={() => setIsShow(true)} />
                    ) : (
                        <MdExpandLess color="orange" onClick={() => setIsShow(false)} />
                    )}
                </div>
            </Title>
            {isShow && (
                <>
                    <table>
                        <thead>
                            <tr>
                                <th>ID.</th>
                                <th>
                                    Thickness <br />
                                    (mm)
                                </th>
                                <th>Factor</th>
                                <th>
                                    Unit W't <br />
                                    (kg/m)
                                </th>
                                <th>
                                    Length <br /> (m)
                                </th>
                                <th>중량(kg)</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {newDeckingPlate &&
                                newDeckingPlate.map((deckingPlate, index) => (
                                    <tr key={index}>
                                        <td>{deckingPlate.id}</td>
                                        <td>{deckingPlate.thickness}</td>
                                        <td>{deckingPlate.factor}</td>
                                        <td>{deckingPlate.unitWeight}</td>
                                        <td>{deckingPlate.length}</td>
                                        <td>{deckingPlate.weight}</td>
                                        <td
                                            className="btn-delete"
                                            onClick={() => onDeleteDeckingPlate(deckingPlate.id)}
                                        >
                                            <MdRemoveCircleOutline />
                                        </td>
                                    </tr>
                                ))}
                            <tr>
                                <td></td>
                            </tr>{' '}
                            {/* 행 사이의 간격을 띄우기 위해 */}
                            <tr>
                                <td></td>
                            </tr>{' '}
                            {/* 행 사이의 간격을 띄우기 위해 */}
                            <tr className="input-form">
                                {/* <td><StyledInput readOnly value={id} onChange={(e) => setId(e.target.value)} /></td> */}
                                <td className="id-column">{id}</td>
                                <td className="td-radio">
                                    <div className="input-radio">
                                        <label>
                                            <input
                                                type="radio"
                                                name="densityCategory"
                                                value="1.5"
                                                onChange={(e) => setThickness(e.target.value)}
                                            />
                                            <span>1.5mm</span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="densityCategory"
                                                value="2.0"
                                                onChange={(e) => setThickness(e.target.value)}
                                            />
                                            <span>2.0mm</span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="densityCategory"
                                                value="2.5"
                                                onChange={(e) => setThickness(e.target.value)}
                                            />
                                            <span>2.5mm</span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="densityCategory"
                                                value="3.0"
                                                onChange={(e) => setThickness(e.target.value)}
                                            />
                                            <span>3.0mm</span>
                                        </label>
                                    </div>
                                </td>
                                <td>
                                    <StyledInput
                                        placeholder="..."
                                        value={factor}
                                        onChange={(e) => setFactor(e.target.value)}
                                    />
                                </td>
                                <td>{unitWeight}</td>
                                <td>
                                    <StyledInput
                                        placeholder="..."
                                        value={length}
                                        onChange={(e) => setLength(e.target.value)}
                                    />
                                </td>
                                <td className="total-weight">{weight}</td>
                                <td className="btn-add" onClick={onAddDeckingPlate}>
                                    <MdAdd />
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan={4}>Decking Plate Total</td>
                                <td>{totalLength}</td>
                                <td>{totalWeight}</td>
                            </tr>
                        </tfoot>
                    </table>
                    {/* <ActionButtons confirmText="Save" cancelText="Cancel Change" onConfirm={onSaveDeckingPlate} onCancel={onClickCancel} /> */}
                    {/* <AskCancelModal visible={modal} onConfirm={onCancelChange} onCancel={() => setModal(false)} /> */}
                </>
            )}
        </DeckingPlateFormBlock>
    );
};

/* =================   Styles   ================== */
const Title = styled.div`
    display: flex;
    align-items: flex-end;
    margin-bottom: 1rem;

    color: ${palette.cyan[6]};
`;

const DeckingPlateFormBlock = styled.div`
    // max-width: 1280px;
    // margin: 0 auto;
    // margin: 0 2rem;
    .btn-delete {
        color: ${palette.cyan[6]};
        font-size: 1rem;
        cursor: pointer;
        padding: 0 1rem;
        padding-top: 0.3rem;
        &:hover {
            color: ${palette.cyan[4]};
        }
    }
    .btn-add {
        color: ${palette.cyan[6]};
        font-size: 1.5rem;
        cursor: pointer;
        padding: 0;
        padding-top: 0.4rem;
        &:hover {
            color: ${palette.cyan[4]};
        }
    }
    table {
        width: 100%;
        font-size: 0.9rem;
        border-collapse: collapse;
    }
    thead {
        border-top: 1px solid ${palette.gray[4]};
        border-bottom: 1px solid ${palette.gray[4]};
        color: ${palette.gray[7]};
    }
    tfoot {
        border-top: 1px solid ${palette.gray[4]};
        border-bottom: 1px solid ${palette.gray[4]};
        height: 2.5rem;
        font-weight: bold;
        color: ${palette.gray[7]};
    }
    th {
        padding: 0.5rem 0.25rem;
        text-align: center;
    }
    td {
        padding: 0.25rem 0.25rem;
        text-align: center;
    }
    .td-radio {
        display: flex;
        justify-content: center;
        margin: 0 auto;
    }
    .input-radio {
        // display: flex;
        flex-direction: column;
        // margin: 0 auto;
        align-items: flex-start;
        span {
            margin-left: 0.5rem;
        }
        // 추가함
        label + label {
            margin-left: 0.5rem;
        }
        // background-color: red;
    }
    h3 {
        color: ${palette.cyan[6]};
    }
    .input-form {
        background-color: ${palette.gray[0]};
    }
    .right-align {
        text-align: right;
    }
`;

const StyledInput = styled.input`
    border: none;
    outline: none;
    padding: 0.25rem 0.5rem;
    width: 50px;
    text-align: center;
    background: transparent;
    &:hover {
        background: ${palette.gray[3]};
    }
`;

export default DeckingPlateForm;
